import React, { useState, useEffect, useReducer } from 'react';
import { Switch, Route, Link, useParams, useHistory } from 'react-router-dom';
import moment from 'moment-timezone';
import './light.css';
import { Button, Container, Dropdown, Grid, Header, Icon, Image, Input, Item, Segment, Table } from 'semantic-ui-react';
import { statusColor, getDiscourseLink, isAdmin, isInstructor, BasicTable, staticUrl, requester } from './utils.js';
import { NotFound } from './Misc.js';
import { AdminMemberInfo, AdminAccounting, AdminMemberPause, AdminMemberForm, AdminMemberCards, AdminMemberTraining, AdminMemberCertifications } from './AdminMembers.js';
import { AdminMemberTransactions } from './AdminTransactions.js';
import { AdminHistory } from './Admin.js';
import { StorageLinks } from './Storage.js';
import AbortController from 'abort-controller';

const isAnniversary = (applicationDate) => {
	if (!applicationDate) {
		return false;
	}

	const today = moment();
	const appDate = moment(applicationDate);

	// Don't show cake on the first day.
	if (today.isSame(appDate, 'day')) {
		return false;
	}

	let appMonth = appDate.month();
	let appDay = appDate.date();

	const todayMonth = today.month();
	const todayDay = today.date();

	// Handle Feb 29 on non-leap years
	if (appMonth === 1 && appDay === 29 && !today.isLeapYear()) {
		appDay = 28;
	}

	return todayMonth === appMonth && todayDay === appDay;
};

const memberSorts = {
	recently_vetted: 'Recently Vetted',
	last_scanned: 'Last Scanned',
	pinball_score: 'Pinball Score',
	newest_active: 'Newest',
	//newest_overall: 'Newest Overall',
	oldest_active: 'Oldest',
	//oldest_overall: 'Oldest Overall',
	recently_inactive: 'Recently Inactive',
	is_director: 'Directors',
	is_admin: 'Portal Admin',
	is_instructor: 'Instructors',
	due: 'Due',
	overdue: 'Overdue',
	storage: 'Storage',
	everyone: 'Everyone',
};

export function MembersDropdown(props) {
	const { token, name, onChange, value, initial, autofocus, filterActive } = props;
	const [response, setResponse] = useState({ results: [] });
	const searchDefault = {seq: 0, q: initial || '', sort: 'newest_active'};
	const [search, setSearch] = useState(searchDefault);

	useEffect(() => {
		requester('/search/', 'POST', token, search)
		.then(res => {
			if (!search.seq || res.seq > response.seq) {
				if (filterActive) {
					setResponse({...res, results: res.results.filter(x => ['Prepaid', 'Current', 'Due', 'Overdue'].includes(x.member.status))});
				} else {
					setResponse(res);
				}
			}
		})
		.catch(err => {
			console.log(err);
		});
	}, [search]);

	const options = response.results.map((x, i) => ({
		key: x.member.id,
		value: x.member.id,
		text: x.member.preferred_name + ' ' + x.member.last_name,
		image: { avatar: true, src: x.member.photo_small ? staticUrl + '/' + x.member.photo_small : '/nophoto.png' },
	}));

	return (
		<Dropdown
			clearable
			fluid
			selection
			search
			name={name}
			options={options}
			value={value}
			placeholder='Search for Member'
			onChange={onChange}
			onSearchChange={(e, v) => setSearch({seq: parseInt(e.timeStamp), q: v.searchQuery, sort: 'newest_active'})}

			searchInput={{ autoFocus: autofocus }}
			openOnFocus={!autofocus}
		/>

	);
};

let responseCache = false;
let pageCache = 0;
let sortCache = '';
let searchCache = '';

const loadMoreStrings = [
	'Load More',
	'Load EVEN More',
	'Load WAY More',
	'Why did you stop? LOAD MORE!',
	'GIVE ME MORE NAMES!!',
	'Shower me with names, baby',
	'Throw some more names on this page',
	'I don\'t care about the poor server, MORE NAMES!',
	'I am the scrolling and the scrolling is me',
	'Names make me hotter than two rats in a wool sock',
	'Holy shit, I can\'t get enough names',
	'One million years of loading',
	'This database can sing!',
	'I don\'t have anything better to do than LOAD NAMES!',
	'My CPU screams but I can only hear the names',
	'The API is bleeding strings',
	'NULL IS BUT A DREAM',
	'I need names because I love N̶a̸M̸E̵S̴ it\'s not to late to stop but I can\'t because it feels so good god help me',
	'The One who loads the names will liquify the NERVES of the sentient whilst I o̴̭̐b̴̙̾s̷̺͝ē̶̟r̷̦̓v̸͚̐ę̸̈́ ̷̞̒t̸͘ͅh̴͂͜e̵̜̕i̶̾͜r̷̃͜ ̵̹͊Ḷ̷͝Ȍ̸͚Ä̶̘́D̴̰́I̸̧̚N̵͖̎G̷̣͒',
	'The Song of Names will will e̶̟̤͋x̷̜̀͘͜t̴̳̀i̸̪͑̇n̷̘̍g̵̥̗̓ṳ̴̑̈́i̷͚̿s̸̨̪̓ḣ̶̡̓ ̷̲͊ṫ̴̫h̸̙͕͗ḛ̸̡̃̈́ ̷̘̫̉̏v̸̧̟͗̕o̴͕̾͜i̷̢͛̿ͅc̴͕̥̈́̂ȅ̵͕s̶̹͋̀ ̶̰́͜͠ǒ̷̰̯f̵̛̥̊ ̸̟̟̒͝m̸̯̀̂o̶̝͛̌͜r̸̞̀ṫ̴̥͗ä̶̢́l̶̯̄͘ ̵̫̈́m̷̦̑̂ą̶͕͝ṋ̴̎͝ from the sphere I can see it can you see it it is beautiful',
	'F̵́ë̵́ė̶d̶̑  t̴̉p̴͋h̴̎e̸͠  e̵͗n̴̈t̵͂r̸̈́o̷͘p̷̏y̵̅ u̴̓n̵͒t̷͐ỉ̷l̵ t̴̔h̴̉e̶̎ s̵͂c̷͒r̷̆ė̴e̵̋n̸͗ d̴̅i̶̛ẻ̷s',
	'I̴͝N̴͂J̵̋E̵̾S̸̅T̵̎ T̶͑Ḧ̴́E̸͂ R̷̈E̸͆C̵̈́O̸͝R̴͠D̷͂S̷̐',
	'T̷̽H̴͝É̶ D̴̈A̸͋T̸̎Ã̴ S̵̾L̸͛Ȗ̴R̷̅P̴͊S̴̅ Ú̴P̴̏Ö̷N̷̓ Ỳ̵O̴͗U̶͗R̴͒  Ś̴Ơ̸Ũ̴L',
	'EEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEE',
	'*server explodes*',
];

export function Members(props) {
	const [response, setResponse] = useState(responseCache);
	const [loading, setLoading] = useState(false);
	const [page, setPage] = useState(pageCache);
	const [sort, setSort] = useState(sortCache);
	const [search, setSearch] = useState(searchCache);
	const [controller, setController] = useState(false);
	const { token, user } = props;
	const history = useHistory();

	const makeRequest = ({loadPage, q, sort_key}) => {
		let pageNum = 0;
		if (loadPage) {
			pageNum = page + 1;
			setPage(pageNum);
			pageCache = pageNum;
		} else {
			setResponse(false);
			setPage(0);
			pageCache = 0;
		}

		if (controller) {
			controller.abort();
		}
		const ctl = new AbortController();
		setController(ctl);
		const signal = ctl.signal;

		const data = {page: pageNum};
		if (q) data.q = q;
		if (sort_key) data.sort = sort_key;

		requester('/search/', 'POST', token, data, signal)
		.then(res => {
			const r = loadPage ? {...response, results: [...response.results, ...res.results]} : res;
			setResponse(r);
			responseCache = r;
			setLoading(false);
		})
		.catch(err => {
			console.log('Aborted.');
		});
	}

	const loadMore = () => {
		setLoading(true);
		makeRequest({loadPage: true, q: search, sort_key: sort});
	};

	const doSort = (sort_key) => {
		setSort(sort_key);
		sortCache = sort_key;
		setSearch('');
		searchCache = '';
		makeRequest({loadPage: false, sort_key: sort_key});
	};

	const doSearch = (q) => {
		if (q) {
			setSearch(q);
			searchCache = q;
			setSort('');
			sortCache = '';
			makeRequest({loadPage: false, q: q});
		} else {
			doSort('recently_vetted');
		}
	};

	const handleChange = (event) => {
		const q = event.target.value;
		doSearch(q);
	};

	useEffect(() => {
		if (!responseCache) {
			doSort('recently_vetted');
		}
	}, []);

	return (
		<Container>
			<Header size='large'>Member List</Header>

			<p>Search by name, email, Spacebar username, member ID, or member storage:</p>

			<Input focus icon='search'
				placeholder='Search...'
				value={search}
				onChange={handleChange}
				aria-label='search products'
				style={{ marginRight: '0.5rem' }}
			/>

			{search.length ?
				<Button
					content='Clear'
					onClick={() => doSearch('')}
				/> : ''
			}

			<p></p>

			<p className='links-menu'>
				Sort by{' '}
				{Object.entries(memberSorts).map((x, i) =>
					<React.Fragment key={x[0]}>
						<a onClick={() => doSort(x[0])}>{x[1]}</a>
						{i < Object.keys(memberSorts).length - 1 && ', '}
					</React.Fragment>
				)}.
			</p>

			<Header size='medium'>
				{search.length ? 'Search Results' : memberSorts[sort]}
			</Header>

			{sort === 'last_scanned' &&
				(user.member.allow_last_scanned ?
					<p>Hide yourself from this list on the <Link to='/account'>Account Settings</Link> page.</p>
				:
					<p>Participate in this list on the <Link to='/account'>Account Settings</Link> page.</p>
				)
			}

			{response ?
				<>
					<p>{response.total} result{response.total === 1 ? '' : 's'}:</p>

					<Item.Group unstackable divided>
						{!!response.results.length &&
							response.results.map((x, i) =>
								<Item key={x.member.id} as={Link} to={'/members/'+x.member.id}>
									<Item.Image size='tiny' src={x.member.photo_small ? staticUrl + '/' + x.member.photo_small : '/nophoto.png'} />
									<Item.Content verticalAlign='top'>
										<Item.Header>
											<Icon name='circle' color={statusColor[x.member.status]} />
											{x.member.preferred_name} {x.member.last_name}{isAnniversary(x.member.application_date) && ' 🎂'}
										</Item.Header>
										{sort === 'pinball_score' ?
											<>
												<Item.Description>Score: {x.member.pinball_score.toLocaleString() || 'Unknown'}</Item.Description>
												<Item.Description>Rank: {i === 0 ? 'Pinball Wizard' : 'Not the Pinball Wizard'}</Item.Description>
											</>
										:
											<>
												{sort === 'newest_active' ?
													<Item.Description>Started: {x.member.current_start_date || 'Unknown'}</Item.Description>
												:
													<Item.Description>Joined: {x.member.application_date || 'Unknown'}</Item.Description>
												}

												<Item.Description>Vetted: {x.member.vetted_date || 'Probationary'}</Item.Description>

												{sort === 'newest_active' ?
													<Item.Description>Helper: {x.member?.signup_helper?.name || 'Unknown'}</Item.Description>
												:
													x.member.status === 'Eternal Member' ?
														<Item.Description>Status: Eternal Member</Item.Description>
													:
														<Item.Description>
															Storage: {x.member.storage.length ?
																<StorageLinks storage={x.member.storage} />
															:
																'None'
															}
														</Item.Description>
												}

												<Item.Description style={{overflowWrap: 'break-word'}}>
													{x.member.public_bio.substring(0, 100)}
													{x.member.public_bio.length > 100 && '...'}
												</Item.Description>
											</>
										}
									</Item.Content>
								</Item>
							)
						}
					</Item.Group>

					{!search && response.total !== response.results.length &&
						<Button content={loading ? 'Reticulating splines...' : loadMoreStrings[page]} onClick={loadMore} disabled={loading} />
					}
				</>
			:
				<p>Loading...</p>
			}

		</Container>
	);
};

let resultCache = {};

export function MemberDetail(props) {
	const id = parseInt(useParams().id)
	const [result, setResult] = useState(resultCache[id] || false);
	const [refreshCount, refreshResult] = useReducer(x => x + 1, 0);
	const [error, setError] = useState(false);
	const { token, user } = props;
	const member = result.member || false;
	const photo = member?.photo_large || member?.photo_small || false;

	useEffect(() => {
		requester('/search/'+id+'/', 'GET', token)
		.then(res => {
			setResult(res);
			resultCache[id] = res;
		})
		.catch(err => {
			console.log(err);
			setError(true);
		});
	}, [id, refreshCount]);

	return (
		<Container>
			{!error ?
				member && member.id === id ?
					<div>
						<Header size='large'>{member.preferred_name} {member.last_name}{isAnniversary(member.application_date) && ' 🎂'}</Header>

						{getDiscourseLink(member) && <p><a href={getDiscourseLink(member)} target='_blank'>[message]</a></p>}

						{isAdmin(user) &&
							<p className='links-menu'>Admin: {' '}
								<Link to={'/members/'+member.id}>Profile</Link>{' - '}
								<Link to={'/members/'+member.id+'/details'}>Details</Link>{' - '}
								<Link to={'/members/'+member.id+'/cards'}>Cards</Link>{' - '}
								<Link to={'/members/'+member.id+'/lockouts'}>Lockouts</Link>{' - '}
								<Link to={'/members/'+member.id+'/training'}>Training</Link>{' - '}
								<Link to={'/members/'+member.id+'/transactions'}>Transactions</Link>{' - '}
								<Link to={'/members/'+member.id+'/accounting'}>Accounting</Link>{' - '}
								<Link to={'/members/'+member.id+'/history'}>History</Link>
							</p>
						}

						{user.member.is_vetter &&
							<p className='links-menu'>Vetting: {' '}
								<Link to={'/members/'+member.id}>Profile</Link>{' - '}
								<Link to={'/members/'+member.id+'/cards'}>Cards</Link>
							</p>
						}

						<Switch>
							{isAdmin(user) && <Route path='/members/:id/details'>
								<Grid stackable columns={2}>
									<Grid.Column width={8}>
										<AdminMemberInfo result={result} refreshResult={refreshResult} {...props} />

										<Segment padded>
											<AdminMemberPause result={result} refreshResult={refreshResult} {...props} />
										</Segment>
									</Grid.Column>

									<Grid.Column width={8}>
										<Segment padded>
											<AdminMemberForm result={result} refreshResult={refreshResult} {...props} />
										</Segment>
									</Grid.Column>
								</Grid>
							</Route>}

							{(isAdmin(user) || user.member.is_vetter) && <Route path='/members/:id/cards'>
								<AdminMemberCards result={result} refreshResult={refreshResult} {...props} />
							</Route>}

							{isAdmin(user) && <Route path='/members/:id/lockouts'>
								<AdminMemberCertifications result={result} refreshResult={refreshResult} {...props} />
							</Route>}

							{isAdmin(user) && <Route path='/members/:id/training'>
								<AdminMemberTraining result={result} refreshResult={refreshResult} {...props} />
							</Route>}

							{isAdmin(user) && <Route path='/members/:id/transactions'>
								<AdminMemberTransactions result={result} refreshResult={refreshResult} {...props} />
							</Route>}

							{isAdmin(user) && <Route path='/members/:id/history'>
								<AdminHistory filterMember={member.id} {...props} />
							</Route>}

							{isAdmin(user) && <Route path='/members/:id/accounting'>
								<AdminAccounting result={result} {...props} />
							</Route>}

							<Route path='/members/:id'>
								<Grid stackable columns={2}>
									<Grid.Column width={5}>
										<p>
											<Image rounded size='medium' src={photo ? staticUrl + '/' + photo : '/nophoto.png'} />
										</p>

										<>
											<BasicTable>
												<Table.Body>
													<Table.Row>
														<Table.Cell>Status:</Table.Cell>
														<Table.Cell>
															<Icon name='circle' color={statusColor[member.status]} />
															{member.status || 'Unknown'}
														</Table.Cell>
													</Table.Row>
													<Table.Row>
														<Table.Cell>Storage:</Table.Cell>
														<Table.Cell>
															{member.storage.length ?
																<StorageLinks storage={member.storage} />
															:
																'None'
															}
														</Table.Cell>
													</Table.Row>
													<Table.Row>
														<Table.Cell>Joined:</Table.Cell>
														<Table.Cell>{member.application_date || 'Unknown'}</Table.Cell>
													</Table.Row>
													<Table.Row>
														<Table.Cell>Vetted:</Table.Cell>
														<Table.Cell>{member.vetted_date ? member.vetted_date + ' ✅' : 'Probationary'}</Table.Cell>
													</Table.Row>
													<Table.Row>
														<Table.Cell>Signup Helper:</Table.Cell>
														<Table.Cell>
															{member.signup_helper ?
																<Link to={'/members/'+member.signup_helper.id}>{member.signup_helper.name}</Link>
															:
																'Unknown'
															}
														</Table.Cell>
													</Table.Row>
													<Table.Row>
														<Table.Cell>Public Bio:</Table.Cell>
														<Table.Cell></Table.Cell>
													</Table.Row>
												</Table.Body>
											</BasicTable>

											<p className='bio-paragraph'>
												{member.public_bio || 'None'}
											</p>
										</>
									</Grid.Column>

									<Grid.Column width={11}>
										{isInstructor(user) && !isAdmin(user) &&
											<AdminMemberTraining result={result} refreshResult={refreshResult} {...props} />
										}
									</Grid.Column>
								</Grid>
							</Route>
						</Switch>
					</div>
				:
					<p>Loading...</p>
			:
				<NotFound />
			}
		</Container>
	);
};
